var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer" }, [
    _c(
      "div",
      { staticClass: "links" },
      _vm._l(_vm.linkList, function(item, index) {
        return _c(
          "a",
          {
            key: index,
            attrs: {
              target: "_blank",
              href: item.link ? item.link : "javascript: void(0)"
            }
          },
          [
            item.icon ? _c("a-icon", { attrs: { type: item.icon } }) : _vm._e(),
            _vm._v(_vm._s(item.name) + "\n      ")
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09d59e5d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09d59e5d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/GlobalFooter.vue
// module id = null
// module chunks = 